import Alpine from "alpinejs";
import { AlpineComponentTryba } from '../../../scripts/alpine/include/global';

const isMultiple = false;

document.addEventListener("alpine:init", () => {
    Alpine.data("accordion", (): AlpineComponentTryba => ({
        active: [],
        showMore: false,
        setMaxHeight(content, height = 0) {
            content.style.maxHeight = height + "px";
        },

        getContent(id) {
            return this.$refs["container-" + id];
        },

        isOpen(id) {
            return this.active.indexOf(id) !== -1;
        },

        close(id) {
            this.active = this.active.filter((accordion) => accordion !== id);
            const content = this.getContent(id);
            this.setMaxHeight(content);
        },

        closeAll() {
            this.active.forEach((el) => {
                this.close(el);
            });
        },

        open(id) {
            const content = this.getContent(id);
            if (this.isOpen(id)) {
                this.close(id);
            } else {
                if (!isMultiple) {
                    this.closeAll()
                }
                this.active.push(id);
                const contentHeight = content.scrollHeight;
                this.setMaxHeight(content, contentHeight);
            }
        },
        recalculate_height(id) {
            setTimeout(() => {
                const content = this.getContent(id);
                const contentHeight = content.scrollHeight;
                this.setMaxHeight(content, contentHeight);
            }, 100)
        },
        firstOpening(id, type) {
            const content = this.getContent(id);
            let height = 0

            if ((!this.$store.global.isMobile && type === 'desktop') || (this.$store.global.isMobile && type === 'mobile') || (type === 'both')) {
                setTimeout(() => {
                    content.querySelectorAll('section').forEach((el) => {
                        height += el.scrollHeight
                    })
                    this.active.push(id);
                    this.setMaxHeight(content, height);
                }, 1000)
            } else {
                return;
            }
        }
    }));
});
